import { inViewPort } from "../utils/inViewPort";
export class LazyLoad {
    constructor(img) {
        this.image = img;
        const { src = "", srcset = "" } = this.image.dataset;
        this.src = src;
        this.srcset = srcset;
        this.loaded = false;
        this.init();
    }
    init() {
        inViewPort(this.image, () => {
            if (this.src) {
                this.image.setAttribute("src", this.src);
            }
            if (this.srcset) {
                this.image.setAttribute("srcset", this.srcset);
            }
            this.image.classList.add("loaded");
            this.loaded = true;
        });
    }
}
const LazyLoadInit = {
    init() {
        const elements = document.querySelectorAll(".lazy-image");
        Array.from(elements).map((element) => new LazyLoad(element));
    },
};
export default LazyLoadInit;
